import axios from "axios";

import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";
import fileDownload from 'js-file-download';

const getUsers = async (params: any) => {
  const url = endpoints.USERS;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params
  });

  return response;
};

const createUser = async (params: any) => {
  const url = endpoints.CREATE_USER;

  const { data: response } = await axios.post(url, params?.data, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const viewUser = async (viewId: any) => {
  const url = endpoints.VIEW_USER(viewId);

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const editUser = async (params: any) => {
  const url = endpoints.EDIT_PROFILE(params?.data.id);

  const { data: response } = await axios.patch(url, params?.data, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteUser = async (userId: any) => {
  const url = endpoints.PROFILE(userId);

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

// Search employees by keyword/name
const searchUsers = async (keyword: string) => {
  const url = endpoints.USERS;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: {
      keyword,
      is_employee: true,
    }
  });

  return response;
};

const uploadBulk = async (params: any) => {
  const url = endpoints.USERS + '/upload/bulk';
  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const getBulkTemplate = async () => {
  const url = endpoints.USERS + '/upload/bulk-template';
  await axios
    .get(url, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "arraybuffer",
  }).then((res) => {
    var blob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileDownload(blob, `bulk_user_template.xlsx`);
  });
};

const exportAllUsers = async () => {
  const url = endpoints.USERS + '/export/all-users';
  await axios
    .get(url, {
      headers: {
        Authorization: accessToken,
        ContentType:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "arraybuffer",
  }).then((res) => {
    var blob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileDownload(blob, `all_users.xlsx`);
  });
};

const service = {
  getUsers,
  createUser,
  editUser,
  viewUser,
  deleteUser,
  searchUsers,
  uploadBulk,
  getBulkTemplate,
  exportAllUsers,
};

export default service;